import React from 'react';
import footerImage from '../assets/images/footer.jpg';
import stripeImage from '../assets/images/stripe.png';
import breakspollLogo from '../assets/images/breakspoll-logo.svg';
import { footerSources, stripeSources } from '../assets/images/responsiveImages';
import '../assets/css/footer.css';

const FooterSection = () => {
  return (
    <section id="contact" className="footer-section section-breakpoint">
      <picture>
        <source
          type="image/webp"
          srcSet={`${footerSources.small} 640w, ${footerSources.medium} 1280w, ${footerSources.desktop} 1600w, ${footerSources.large} 1920w`}
          sizes="100vw"
        />
        <img src={footerImage} alt="" className="footer-bg" loading="lazy" decoding="async" />
      </picture>
      <div className="footer-overlay">
        <picture>
          <source
            type="image/webp"
            srcSet={`${stripeSources.small} 640w, ${stripeSources.medium} 1280w, ${stripeSources.desktop} 1600w, ${stripeSources.large} 1900w`}
            sizes="100vw"
          />
          <img src={stripeImage} alt="" className="stripe" loading="lazy" decoding="async" />
        </picture>
        <div className="scanline-overlay"></div>
        <div className="blue-tint"></div>
      </div>
      <div className="footer-content">
        {/* Social Links - Top Left */}
        <div className="footer-social">
          <a href="mailto:info@breakspoll.com">EMAIL</a>
          <a href="https://instagram.com/breakspoll" target="_blank" rel="noreferrer">INSTAGRAM</a>
          <a href="https://facebook.com/breakspoll" target="_blank" rel="noreferrer">FACEBOOK</a>
          <a href="https://x.com/breakspoll" target="_blank" rel="noreferrer">X</a>
        </div>

        <img src={breakspollLogo} alt="Breakspoll Logo" className="breakspoll-logo" />

        {/* Copyright - Bottom Left */}
        <div className="footer-copyright">
          <p>©Breakspoll</p>
        </div>

        {/* Legal Link - Bottom Right */}
        <div className="footer-legal">
          <a href="/legal">Legal</a>
        </div>
      </div>
    </section>
  );
};

export default FooterSection;
